export default "__VITE_ASSET__VU3EDzwe__"